import Enum from '@rover/react-lib/types/Enum';

export class APIVersion extends Enum<String> {
  static v3 = new APIVersion('v3');
  static v4 = new APIVersion('v4');
}

export const frontendDefaultApiVersion = APIVersion.v3;

export const apiUrl = (suffix = '', version = frontendDefaultApiVersion) =>
  `/api/${version}/${suffix}`;

export const fullApiUrl = (suffix, version, location = window.location) => {
  const path = apiUrl(suffix, version);
  const base = `${location.protocol}//${location.hostname}${
    location.port ? `:${location.port}` : ''
  }`;

  return `${base}${path}`;
};

export default {
  apiUrl,
  fullApiUrl,
  frontendDefaultApiVersion,
};



// WEBPACK FOOTER //
// ../utilities/apiUrl.js